<div class="newsletter-modal-inner">
  <div class="h2" *ngIf="data.title" [innerHTML]="data.title"></div>
  <div class="newsletter-modal-iframe" *ngIf="data.iframe" [innerHTML]="data.iframe|safeHtml">

  </div>
</div>
